import { PositionData } from "../types/crowdhandler";

const calculateProgress = (positionData: PositionData, currentPosition: number) => {

        const defaultProgress = 10;

        // Guard against invalid inputs
        if (!positionData?.firstPosition || !Number.isFinite(positionData.firstPosition)) {
            return defaultProgress;
        }

        if (!Number.isFinite(currentPosition) || currentPosition < 0) {
            return defaultProgress;
        }

        let progress = ((positionData.firstPosition - currentPosition) / positionData.firstPosition) * 100;

        // Guard against NaN or Infinity from calculation
        if (!Number.isFinite(progress)) {
            return defaultProgress;
        }

        if (progress < defaultProgress) {
            progress = defaultProgress;
        }

        return Math.round(progress);
    };

export { calculateProgress }